import React from 'react';

const CertificadoExpirado = () => {

  return (
    <div className="min-h-screen bg-white flex flex-col items-center p-4 font-sans text-slate-700">
      
      {/* Logo */}
      <div className="flex items-center gap-2 mb-8 mt-4">
        <div className="text-blue-900">
          {/* Icono de avión simple */}
          <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
            <path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z text-blue-900" />
          </svg>
        </div>
        <div className="flex flex-col leading-none">
          <span className="text-blue-900 font-bold text-xl tracking-tight">Seguro</span>
          <div className="flex items-center">
            <span className="text-xs text-blue-900 mr-1">para</span>
            <span className="text-pink-600 font-bold text-xl tracking-tight italic">Viaje</span>
          </div>
        </div>
      </div>

      {/* Mensaje Principal */}
      <div className="max-w-2xl text-center mb-6 px-4">
        <p className="text-lg leading-relaxed text-blue-900">
          SEÑOR(A), El número de certificado se encuentra <span className="font-bold text-slate-800 underline decoration-slate-400 underline-offset-4">Expirado</span>, se ha negado el acceso visual a su: Certificado
        </p>
      </div>

      {/* Línea divisoria punteada */}
      <div className="w-full max-w-4xl border-t border-dotted border-slate-400 mb-8"></div>

      {/* Título de estado */}
      <h2 className="text-2xl font-bold text-blue-900 mb-12">
        Certificado Expirado.
      </h2>

      {/* Ilustración del Monitor */}
      <div className="relative flex flex-col items-center">
        
        {/* Cuerpo del monitor/ventana */}
        <div className="w-72 h-48 bg-white border-4 border-slate-300 rounded-xl shadow-2xl overflow-hidden relative z-10">
          {/* Barra superior de la ventana */}
          <div className="h-8 bg-slate-700 flex items-center px-3 gap-1">
            <div className="w-2 h-2 rounded-full bg-slate-500"></div>
            <div className="w-2 h-2 rounded-full bg-slate-500"></div>
            <div className="w-2 h-2 rounded-full bg-slate-500"></div>
            <div className="ml-4 h-3 w-32 bg-slate-600 rounded"></div>
            <div className="ml-auto h-3 w-6 bg-slate-600 rounded"></div>
          </div>

          {/* Contenido (Cara triste) */}
          <div className="flex flex-col items-center justify-center h-full pb-8">
            <div className="flex justify-around w-full px-12 mb-4">
              {/* Ojos X */}
              <div className="text-slate-600 text-3xl font-light">✕</div>
              <div className="text-slate-600 text-3xl font-light">✕</div>
            </div>
            {/* Boca */}
            <div className="w-20 h-0.5 bg-slate-600"></div>
          </div>

          {/* Barra inferior decorativa */}
          <div className="absolute bottom-3 left-4 right-4 h-1.5 bg-slate-700 rounded-full"></div>
        </div>

        {/* Brazos */}
        <div className="absolute -left-8 top-24 w-8 h-8 border-l-4 border-t-4 border-slate-700 rounded-tl-full rotate-[-10deg]"></div>
        <div className="absolute -right-8 top-24 w-8 h-8 border-r-4 border-t-4 border-slate-700 rounded-tr-full rotate-[10deg]"></div>
        
        {/* Manos */}
        <div className="absolute -left-10 top-[130px] flex gap-0.5">
          <div className="w-1 h-3 bg-slate-700 rounded-full"></div>
          <div className="w-1 h-4 bg-slate-700 rounded-full"></div>
          <div className="w-1 h-3 bg-slate-700 rounded-full"></div>
        </div>
        <div className="absolute -right-10 top-[130px] flex gap-0.5">
          <div className="w-1 h-3 bg-slate-700 rounded-full"></div>
          <div className="w-1 h-4 bg-slate-700 rounded-full"></div>
          <div className="w-1 h-3 bg-slate-700 rounded-full"></div>
        </div>

        {/* Patas */}
        <div className="flex gap-16 -mt-1 relative z-0">
          <div className="w-1 h-12 bg-slate-800"></div>
          <div className="w-1 h-12 bg-slate-800"></div>
        </div>
        
        {/* Pies/Sombra */}
        <div className="w-40 h-6 bg-blue-900/30 rounded-[100%] -mt-3 blur-[1px]"></div>
        
        {/* Líneas de suelo */}
        <div className="absolute -bottom-8 flex gap-32 opacity-40">
           <div className="w-8 h-0.5 bg-slate-800"></div>
           <div className="w-8 h-0.5 bg-slate-800"></div>
        </div>
      </div>

    </div>
  );
};

export default CertificadoExpirado;